/* Delvaxor: white-screen brand transition with native Shopify navigation. */
(function () {
  'use strict';

  var overlay = document.getElementById('DelvaxorPageTransition');
  var state = window.DelvaxorPageTransition;
  if (!overlay || !state) return;

  var root = document.documentElement;
  var main = document.getElementById('MainContent');
  var logo = overlay.querySelector('img');
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var inEditor = overlay.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
  var minDuration = Math.min(3000, Math.max(0, Number(overlay.dataset.minDuration) || 0));
  var fadeDuration = Math.min(600, Math.max(100, Number(overlay.dataset.fadeDuration) || 450));
  var dismissTimer = 0;
  var navigationTimer = 0;
  var navigating = false;
  var generation = 0;
  var savedInert = null;

  function lockContent() {
    if (main && savedInert === null) {
      savedInert = main.inert;
      main.inert = true;
    }
  }

  state.release = function () {
    if (main && savedInert !== null) {
      main.inert = savedInert;
      savedInert = null;
    }
    window.clearTimeout(dismissTimer);
    window.clearTimeout(navigationTimer);
    navigating = false;
    generation += 1;
  };

  function dismissImmediately() {
    overlay.style.transition = 'none';
    state.dismiss(true);
    // Flush the hidden state before restoring fades, including BFCache restores.
    void overlay.offsetWidth;
    overlay.style.removeProperty('transition');
  }

  if (inEditor && overlay.dataset.previewInEditor !== 'true') {
    dismissImmediately();
    return;
  }

  if (root.classList.contains('dv-transition-entering')) {
    lockContent();
    var entryGeneration = generation;
    var logoReady = new Promise(function (resolve) {
      if (!logo || logo.complete) {
        resolve();
        return;
      }
      var imageTimer = window.setTimeout(resolve, 700);
      function ready() {
        window.clearTimeout(imageTimer);
        resolve();
      }
      logo.addEventListener('load', ready, { once: true });
      logo.addEventListener('error', ready, { once: true });
    });
    var pageReady = new Promise(function (resolve) {
      if (document.readyState === 'complete') resolve();
      else window.addEventListener('load', resolve, { once: true });
    });
    Promise.all([logoReady, pageReady]).then(function () {
      if (entryGeneration !== generation || navigating) return;
      var remaining = Math.max(0, minDuration - (Date.now() - state.startedAt));
      dismissTimer = window.setTimeout(function () {
        if (overlay.dataset.loop !== 'true' || motion.matches) { state.dismiss(); return; }
        // Leave from the assembled hold, so the three cuts never snap mid-cycle.
        var cycle = Math.max(600, Number(overlay.dataset.loopDuration) || 1800);
        var phase = (Date.now() - state.startedAt) % cycle;
        var holdStart = cycle * .28 + 180;
        var holdEnd = cycle * .64;
        var wait = phase < holdStart ? holdStart - phase : phase <= holdEnd ? 0 : cycle - phase + holdStart;
        dismissTimer = window.setTimeout(state.dismiss, wait);
      }, motion.matches ? 0 : remaining);
    });
  }

  function eligibleLink(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;
    var element = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = element && element.closest('a[href]');
    if (!link || link.closest('[data-no-transition], [data-no-page-transition]')) return null;
    if (link.hasAttribute('download') || link.hasAttribute('onclick') || link.hasAttribute('data-method') || link.hasAttribute('data-remote')) return null;
    if (link.getAttribute('aria-disabled') === 'true' || link.relList.contains('external')) return null;
    var base = document.querySelector('base[target]');
    var target = link.getAttribute('target') || (base && base.getAttribute('target')) || '';
    if (target && target.toLowerCase() !== '_self') return null;
    var rawHref = link.getAttribute('href').trim();
    if (!rawHref || rawHref.charAt(0) === '#') return null;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return null; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return null;
    if (url.username || url.password) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    // Never delay purchase, account, app, API, or file/download endpoints.
    if (/(?:^|\/)(?:cart|checkout|checkouts|account|customer_authentication|apps|tools|admin|cdn|wallets|payments|challenge|services)(?:\/|$)/i.test(url.pathname)) return null;
    if (/\.[a-z0-9]{1,8}$/i.test(url.pathname) || url.searchParams.has('download')) return null;
    return url;
  }

  if (overlay.dataset.onNavigation === 'true' && !inEditor) {
    // Window bubbling lets product/app handlers cancel their own links first.
    window.addEventListener('click', function (event) {
      if (motion.matches) return;
      var url = eligibleLink(event);
      if (!url) return;
      event.preventDefault();
      if (navigating) return;
      generation += 1;
      navigating = true;
      window.clearTimeout(dismissTimer);
      state.arm();
      lockContent();
      root.classList.remove('dv-transition-entering');
      root.classList.add('dv-transition-leaving');
      navigationTimer = window.setTimeout(function () {
        window.location.assign(url.href);
      }, fadeDuration);
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) dismissImmediately();
  });
  window.addEventListener('pagehide', function () {
    window.clearTimeout(state.guard);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') dismissImmediately();
  });
  if (motion.addEventListener) {
    motion.addEventListener('change', function (event) {
      if (!event.matches) return;
      // A pending click still reaches its intended destination without animation.
      root.classList.remove('dv-transition-entering', 'dv-transition-leaving');
      if (!navigating) dismissImmediately();
    });
  }
}());
